import { combineReducers } from 'redux';

import mall from './mall';

const initialState = {
  mine: {
    data: null,
    loadStatus: 0,
  },
};

function mineReducer(state = initialState.mine, action) {
  switch (action.type) {
    case 'LOAD_MINE': {
      return {
        ...state,
        loadStatus: 1,
      };
    }
    case 'LOAD_MINE_COMPLETION': {
      const { data, error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        data: {
          communityNum: data.communityNum,
          customerNum: data.customerNum,
          referralNum: data.referralNum,
          teamNum: data.teamNum,
          referralNumDirect: data.referralNumDirect,
          giftNum: data.couponAmountVo && data.couponAmountVo.usableNum,
          cashNum: data.couponAmountVo && data.couponAmountVo.usableCashNum,
          postageNum: data.couponAmountVo && data.couponAmountVo.usablePostNum,
          usableStoreNum:
            data.couponAmountVo && data.couponAmountVo.usableStoreNum,
          waitMoney: data.walletVo && data.walletVo.waitMoney,
          money: data.walletVo && data.walletVo.money,
          unPayOrder: data.unPayOrder,
          sentOrder: data.sentOrder,
        },
        loadStatus: 2,
      };
    }

    default:
      return state;
  }
}

function mineLoadStatusReducer(state = 0, action) {
  switch (action.type) {
    case 'LOAD_HOME_MINE': {
      return 1;
    }

    case 'LOAD_HOME_MINE_COMPLETION': {
      return action.error ? 0 : 2;
    }

    default:
      return state;
  }
}

function mineDidLoadAtReducer(state = 0, action) {
  switch (action.type) {
    case 'LOAD_HOME_MINE_COMPLETION': {
      return action.error ? state : action.didLoadAt;
    }

    default:
      return state;
  }
}

export default combineReducers({
  mall,
  mine: combineReducers({
    loadInfo: combineReducers({
      loadStatus: mineLoadStatusReducer,
      didLoadAt: mineDidLoadAtReducer,
    }),
    info: mineReducer,
  }),
});
